import jwtDecode from 'jwt-decode';
import { AuthServiceBase } from './service-auth-base';

export const MSX_AUTH_NOT_FOUND = 'MSXAuthService: MsxAuthenticationService not found';
export const MSX_AUTH_INVALID_TOKEN = 'MSXAuthService: Invalid JWT token received';

/** Checks whether a string looks like a valid JWT (three Base64URL-encoded segments separated by dots). */
const isValidJwt = (token: string): boolean => {
  if (typeof token !== 'string') return false;
  const parts = token.split('.');
  // A valid JWT has exactly 3 non-empty segments containing only Base64URL characters
  return parts.length === 3 && parts.every((part) => part.length > 0 && /^[A-Za-z0-9_-]+={0,2}$/.test(part));
};

export class MSXAuthService extends AuthServiceBase {
  public getAccountInfo = (): Promise<any> =>
    new Promise((resolve, reject) => {
      this.getTokenForScope(this.GRAPH_AUTH_SCOPE).catch((error: Error) => {
        reject(error);
      });
      this.getTokenForScope(this.MEM_AUTH_SCOPE)
        .then((token: string) => {
          if (!isValidJwt(token)) {
            throw new Error(MSX_AUTH_INVALID_TOKEN);
          }
          const decoded: { upn?: string } = jwtDecode(token);
          resolve(decoded.upn);
        })
        .catch((error: Error) => {
          reject(error);
        });
    });

  public getTokenForScope = (scope: string): Promise<string> =>
    new Promise((resolve, reject) => {
      if (!(window as any)?.MsxAuthenticationService) {
        reject(new Error(MSX_AUTH_NOT_FOUND));
      } else {
        (window as any).MsxAuthenticationService.acquireTokenForScope(scope)
          .then((token: string) => {
            resolve(token);
          })
          .catch((error: Error) => {
            reject(error);
          });
      }
    });
}
